import React from 'react';
import { Pager, PageChangeEvent } from '@progress/kendo-react-data-tools';
import { useGetHostConfigQuery } from '../../../../redux/api/AccountApi';
import { useGetUserProfileQuery } from '../../../../redux/api/BaseApi';
import { isMobile } from 'react-device-detect';

export type PagerProps = {
    skip: number;
    total: number;
    onChange: (e: PageChangeEvent) => void;
}

const ActionPager: React.FC<PagerProps> = (props) => {
    const { data: userProfile } = useGetUserProfileQuery()
    //Page size is and System setting
    const { data: hostConfig } = useGetHostConfigQuery(userProfile?.Tenant_Uid, { skip: !userProfile?.Tenant_Uid });

    //If the skip is greater than the total, reset the skip
    if (props.skip > props.total) {
        props.onChange({ skip: 0, take: hostConfig?.Call_Action_Page_Size } as PageChangeEvent);
    }

    if (props.total <= hostConfig?.Call_Action_Page_Size) return null;

    if (!hostConfig) return null;

    return (
        <>
            <Pager
                responsive={true}
                skip={props.skip}
                take={hostConfig?.Call_Action_Page_Size}
                total={props.total}
                onPageChange={props.onChange}
                buttonCount={isMobile ? 5 : 10}
                info={true}
                previousNext={true}
                type="numeric"
                pageSizeValue={hostConfig?.Call_Action_Page_Size}
            />
        </>
    )
};

export default ActionPager;